module.exports = __webpack_public_path__ + "static/media/floppy-drive.5bd1c59d.png";